export function authHeader() {
    // return authorization header with jwt token
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('accessToken');
    if (user && token) {
        return { 'Authorization': 'Bearer ' + token };
    }
}
